export default __webpack_public_path__ + "static/media/paste.95056721.svg";